export default "__VITE_ASSET__BU4RVzNq__"